module.exports = __webpack_public_path__ + "img/new_logo.6daf7a31.png";